<mat-dialog-content>
  <section class="upload-employees-wrapper">
    <h2 class="cmn-popup-title">Add Transaction</h2>
    <button class="cmn-close" mat-dialog-close></button>

    <form [formGroup]="addTransactionForm">
      <div class="account-title-wrapper">
        <p>Account : <span>{{currentBankName || ''}}</span></p>
      </div>

      <div class="form-div">
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type">
              <mat-option value="IN">IN</mat-option>
              <mat-option value="OUT">OUT</mat-option>
            </mat-select>
            <mat-error
              *ngIf="addTransactionForm.get('type')?.hasError('required')"
            >
              Type is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Account -->
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>
              {{ addTransactionForm.get('type')?.value === 'IN' ? 'From Account'
              : addTransactionForm.get('type')?.value === 'OUT' ? 'To Account' :
              'Account' }}
            </mat-label>

            <mat-select formControlName="account">
              <mat-option
                *ngFor="let acc of accounts"
                [value]="acc.id"
                [disabled]="acc.id === currentBankId"
              >
                {{ acc.bankName }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="addTransactionForm.get('account')?.hasError('required')"
            >
              Account is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Amount -->
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Amount</mat-label>
            <input
              matInput
              type="number"
              formControlName="amount"
              (keypress)="allowOnlyNumberWithDecimal($event)"
              (paste)="blockPaste($event)"
            />
            <mat-error
              *ngIf="addTransactionForm.get('amount')?.hasError('required')"
            >
              Amount is required
            </mat-error>
            <mat-error
              *ngIf="addTransactionForm.get('amount')?.hasError('min')"
            >
              Amount must be greater than 0
            </mat-error>
          </mat-form-field>
        </div>

        <!-- transaction category -->
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Transaction Category</mat-label>

            <mat-select formControlName="transactionCategory">
              <mat-option
                style="text-transform: capitalize"
                *ngFor="let category of transactionCategories"
                [value]="category"
              >
                {{ category }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="addTransactionForm.get('transactionCategory')?.hasError('required')"
            >
              Transaction Category is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Transaction Date -->
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Transaction Date</mat-label>
            <input
              matInput
              [matDatepicker]="transactionDatePicker"
              formControlName="transactionDate"
              placeholder="Select transaction date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="transactionDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #transactionDatePicker></mat-datepicker>
            <mat-error
              *ngIf="
                addTransactionForm.get('transactionDate')!.touched &&
                addTransactionForm.get('transactionDate')!.hasError('required')
              "
            >
              Transaction date is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- description -->
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" />
            <mat-error
              *ngIf="addTransactionForm.get('description')?.hasError('required')"
            >
              Description is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- ReferenceNumber -->
        <div class="form-wrapper">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Reference Number</mat-label>
            <input matInput formControlName="referenceNumber" />
            <mat-error
              *ngIf="addTransactionForm.get('referenceNumber')?.hasError('required')"
            >
              Reference Number is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- paid via -->
        <div class="form-wrapper" *ngIf="showPaidVia">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Paid Via</mat-label>

            <mat-select formControlName="paidVia">
              <mat-option
                style="text-transform: capitalize"
                *ngFor="let item of paidViaOptions"
                [value]="item"
              >
                {{ item }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="addTransactionForm.get('paidVia')?.hasError('required')"
            >
              Paid Via is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Submit -->
      <button
        (click)="onAddTransaction()"
        type="submit"
        class="cmn-upload-submit-btn active"
      >
        Save
      </button>
    </form>
  </section>
</mat-dialog-content>
